import React from "react";

const ClientsData = () => {
  return <div>ClientsData</div>;
};

export default ClientsData;
